import Modal from "@/app/core/layouts/main/components/Modal";
import React, { useEffect, useState } from "react";
import Field from "@/app/core/components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import { OnDataChange } from "@/app/core/util/helpers/DataHelper";
import { CategoriesController } from "@/app/core/base/controllers/CategoriesController";
import { FileController } from "@/app/core/base/controllers/FileController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import UploadButton from "@/app/core/layouts/main-components/files/UploadButton";

export default function CategoryModal({ show, onHide, category }) {
    const date = new Date();
    const [url, setUrl] = useState("");
    const [optional, setOptional] = useState({});
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ optionals: [] });
    const [change, setChange] = useState(date.getTime());


    useEffect(() => {
        if (show && category.id) {
            setData(category);
        } else {
            setData({ optionals: [] })
        }
    }, [show]);

    function notifyChange() {
        setChange(date.getTime());
    }

    function handleRealChange(evt, type) {
        setData(OnDataChange(data, evt, type));
    }
    function handleOptionalChange(evt, type) {
        setOptional(OnDataChange(optional, evt, type));
    }

    async function save() {
        let error = false, message = "";

        if (!data.name) {
            error = true;
            message += "Nome; ";
        }
        if (error) {
            toast.error("Esta faltando preencher: " + message);
        } else {
            console.log("DAdos", data);
            let base = data;
            if (base.optionals === undefined || base.optionals.length === 0) {
                delete base.optionals;
            }
            setLoading(true);
            if (!data.id) {
                await CategoriesController.Insert(base, res => {
                    toast.success("Salvo com sucesso");
                });
            } else {
                await CategoriesController.Update(base, res => {
                    toast.success("Salvo com sucesso");
                });
            }
            onHide()
            setLoading(false);

        }
    }

    async function uploadIcon(file) {
        setLoading(true);
        await FileController.Upload(`categorias/opcionais/${file.name}`, file, response => {
            setUrl(response);
            setLoading(false);
        })
    }

    async function uploadHighlight(file, index) {
        setLoading(true);
        await FileController.Upload(`categorias/opcionais/destaque/${file.name}`, file, async response => {
            let newData = data;
            newData.optionals[index].highlight = response;
            await CategoriesController.Update(newData, result => {
                toast.success("Salvo com sucesso");
            });
            setData(newData);
            setLoading(false);
            notifyChange();
        })
    }

    async function uploadCurrentIcon(file, index) {
        setLoading(true);
        await FileController.Upload(`categorias/opcionais/${file.name}`, file, async response => {
            let newData = data;
            newData.optionals[index].icon = response;
            await CategoriesController.Update(newData, result => {
                toast.success("Salvo com sucesso");
            });
            setData(newData);
            setLoading(false);
            notifyChange();
        })
    }

    async function addOnBody(e) {
        e.preventDefault();
        let newData = data;
        if (newData.optionals === undefined) {
            newData.optionals = [];
        }
        newData.optionals.push({ ...optional, icon: url });
        setData(newData);
        notifyChange()
    }

    function removeItem(index) {
        if (window.confirm(Message.DeleteConfirm)) {
            let old = data;
            let newOptionals = [];
            for (let s in old.optionals) {
                if (parseInt(s) !== index) {
                    newOptionals.push(old.optionals[s]);
                }
            }

            setData({ ...old, optionals: newOptionals });
            notifyChange()
        }
    }

    return (
        <Modal title="Categoria de opcionais" show={show} onHide={onHide} isLoading={loading} onSubmit={() => save()}>
            <Field name="name" onChange={evt => handleRealChange(evt)} title={"Nome da categoria"} value={data && data.name} type={FieldTypeObj.Text} />
            <div className="block-header">
                <div className="block-title">
                    <div className="content-heading">
                        <h3>Opcionais</h3>
                    </div>
                </div>
                <div className="block-tools">
                    <Dropdown>
                        <Dropdown.Toggle className="btn btn-warning mt-4">
                            <i className="si si-plus" /> Adicionar opção
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <form onSubmit={(e) => addOnBody(e)}>
                                <Field type={FieldTypeObj.Text} name={"name"} value={optional && optional.name} title={"Nome"} onChange={evt => handleOptionalChange(evt)} />
                                <Field type={FieldTypeObj.Text} name={"message"} value={optional && optional.message} title={"Mensagem de destaque"} onChange={evt => handleOptionalChange(evt)} />
                                <Field type={FieldTypeObj.Select}
                                    name={"describe"}
                                    value={optional && optional.describe}
                                    title={"Precisa descrever?"}
                                    options={[{ name: "Não", value: false }, { name: "Sim", value: true }]}
                                    nameOption={"name"}
                                    keyOption={"value"}
                                    onChange={evt => handleOptionalChange(evt, FieldTypeObj.Bool)} />
                                <span>Ícone</span>
                                <input type="file" className="form-control" onChange={evt => uploadIcon(evt.target.files[0])} />
                                <button type="submit" className="btn btn-success btn-block mt-3">Adicionar</button>
                            </form>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className="block-content">
                {change && data && data.optionals && data.optionals.map((item, index) => (
                    <div className="block block-rounded block-bordered">
                        <div className="block-header">
                            <div className="block-title">
                                {item.highlight ?
                                    <span>
                                        <img src={item.highlight} style={{ width: 78 }} className="mr-2" />
                                    </span>
                                    : ""}
                                <img src={item.icon} style={{ width: 38 }} className="mr-2" />
                                {item.name}</div>
                            <div className="block-tools">
                                <UploadButton upload={files => uploadHighlight(files[0], index)} title={"Adicionar destaque"} />
                                <UploadButton upload={files => uploadCurrentIcon(files[0], index)} title={"Adicionar ícone"} />
                                <button className="btn btn-dual" onClick={() => removeItem(index)}><i className="si si-close text-danger" /></button></div>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
}
